export default "__VITE_PUBLIC_ASSET__6ccf6620__"